'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.reducer = exports.getFormOptions = exports.getFormOptionsErrors = exports.getFormOptionsPending = exports.options = exports.NAME = undefined;
var _axios = require('axios');
var _axios2 = _interopRequireDefault(_axios);
var _reduxPromiseMiddleware = require('redux-promise-middleware');
var _reselect = require('reselect');
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}
function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }
  return obj;
}

// consts
var NAME = exports.NAME = 'markerStudyOptions';
var SET_OPTIONS = '@@marmalade/marker-study/SET_OPTIONS';

// selector
var options = exports.options = (0, _reselect.createSelector)(function (state) {
  return state[NAME];
}, function (formOptions) {
  return Object.keys(formOptions).reduce(function (acc, val) {
    return Object.assign({}, acc, _defineProperty({}, val, formOptions[val].data));
  }, {});
});
var getFormOptionsPending = exports.getFormOptionsPending = (0, _reselect.createSelector)(function (state) {
  return state[NAME];
}, function (formOptions) {
  return Object.keys(formOptions).some(function (key) {
    return formOptions[key].pending;
  });
});
var getFormOptionsErrors = exports.getFormOptionsErrors = (0, _reselect.createSelector)(function (state) {
  return state[NAME];
}, function (formOptions) {
  return Object.keys(formOptions).some(function (key) {
    return formOptions[key].error;
  });
});

// action
var getFormOptions = exports.getFormOptions = function getFormOptions(product, field) {
  var path = void 0;
  switch (field) {
    case 'ownerRelation':
      path = 'owner-relationship?product=' + product;
      break;
    case 'title':
      path = 'titles?product=' + product;
      break;
    case 'keptOvernight':
      path = 'kept-overnight-location';
      break;
    case 'employmentStatus':
      path = 'employment-types?product=' + product;
      break;
    default:
      return;
  }
  return {
    type: SET_OPTIONS,
    meta: {
      field: field
    },
    payload: _axios2.default.get(process.env.REACT_APP_API_BASE_URI + '/shared/v1/public/markerstudy/' + path).then(function (response) {
      return {
        options: response.data.data
      };
    })
  };
};

// reducer
var reducer = exports.reducer = function reducer() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var action = arguments[1];
  if (action.type === SET_OPTIONS + '_' + _reduxPromiseMiddleware.FULFILLED) {
    return Object.assign({}, state, _defineProperty({}, action.meta.field, {
      data: action.payload.options.map(function (option) {
        return Object.assign({}, option, {
          value: String(option.value)
        });
      }),
      error: false,
      pending: false
    }));
  }
  if (action.type === SET_OPTIONS + '_' + _reduxPromiseMiddleware.PENDING || action.type === SET_OPTIONS + '_' + _reduxPromiseMiddleware.REJECTED) {
    return Object.assign({}, state, _defineProperty({}, action.meta.field, {
      data: [],
      error: action.type === SET_OPTIONS + '_' + _reduxPromiseMiddleware.REJECTED,
      pending: action.type === SET_OPTIONS + '_' + _reduxPromiseMiddleware.PENDING
    }));
  }
  return state;
};